import { ReservationConflict, ReservationsResults, Reservation, ReservationType, ReservationOccurrence } from "src/types";
import { createScheduleEvents } from "./createScheduleEvents";
import moment from "moment";

export const detectConflict = (
  startTime: Date | string,
  endTime: Date | string,
  types: ReservationType[],
  movingEvent: ReservationOccurrence,
  existingReservations: Reservation[] | null,
  existingEvents: ReservationOccurrence[] | null,
  ): ReservationConflict => {
    if (typeof startTime === "string") { startTime = moment(startTime).toDate(); }
    if (typeof endTime === "string") { endTime = moment(endTime).toDate(); }
    if ((!existingReservations || existingReservations.length === 0) && (!existingEvents || existingEvents.length === 0)) {
      // No existing reservations or events, so no conflict
      return { hasConflict: false, roomIds: [] };
    }

    const movingReservation = movingEvent.reservation;

    // A reservation can't conflict with itself, so remove it from the list of existing reservations for checking what rooms are in use
    const otherReservations = existingReservations ? existingReservations.filter((reservation) => {
      if(!movingReservation) return true;
      return reservation.id !== movingReservation.id;
    }) : [];

    // Creating events converts recurring reservations into multiple events based on their recurrence rules, if events weren't given
    const events = (existingEvents && existingEvents.length > 0) ? existingEvents : createScheduleEvents(otherReservations, startTime, types);

    // Exclude the moving event from the list of events to check for conflicts
    const otherEvents = events.filter((event) => {
      return event.reservation?.id !== movingReservation?.id;
    });

    const overlappingEvents = otherEvents.filter((event) => {
      const eventStart = moment(event.startDate);
      const eventEnd = moment(event.endDate);
      const movingStart = moment(startTime);
      const movingEnd = moment(endTime);
      return (
        (movingStart.isBefore(eventEnd) && movingEnd.isAfter(eventStart))
      );
    });

    const occupiedRooms: number[] = [];
    overlappingEvents.forEach((event) => {
      if (event.reservation && event.reservation.room_ids) {
        event.reservation.room_ids.forEach((roomId) => {
          if (!occupiedRooms.includes(roomId)) {
            occupiedRooms.push(roomId);
          }
        });
      }
    });

    const movedReservationRoomIds = movingReservation?.room_ids || [];
    const conflictingRooms = movedReservationRoomIds.filter((roomId) =>
      occupiedRooms.includes(roomId)
    );

    const conflict: ReservationConflict = {
      hasConflict: conflictingRooms.length > 0,
      roomIds: conflictingRooms,
    };
    return conflict;
  };